import React from "react";
import styled from "styled-components";

export default function ButtonAction({
  srcBg,
  content,
  handleClick = () => {},
}) {
  return (
    <Div className="button-action-popup-mini" onClick={handleClick}>
      {srcBg && (
        <img src={srcBg} alt="" height={60} />
      ) }
      <div className="content-btn">{content}</div>
    </Div>
  );
}

const Div = styled.div`
  position: relative;
  width: max-content;

  .content-btn {
    position: absolute;
    left: 50%;
    top: calc(50% - 4px);
    transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    font-weight: 500;
    width: max-content;
  }

  @media (min-width: 992px) {
    &:hover {
      scale: 1.03;
      cursor: pointer;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 425px) {
    .content-btn {
      font-size: 14px;
    }
  }
`;
